@if(data.image){
  <img [src]="data.image" alt="">
}
<div mat-dialog-title class="title">{{ data.title | translate }}</div>
<div class="message">{{ data.message | translate }}</div>
@if(data.question){
  <div class="message">{{ data.question | translate }}</div>
}
<div class="actions-container">
  <app-button
    [buttonLabel]="'buttons.no' | translate"
    [buttonType]="BUTTON_TYPES.OUTLINED" 
    [buttonDisabled]="false"
    (click)="action('cancel')">
  </app-button>
  <app-button
    [buttonLabel]="'buttons.yes' | translate"
    [buttonType]="BUTTON_TYPES.REGULAR" 
    [buttonDisabled]="false"
    (click)="action('continue')">
  </app-button>
</div>
